import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToolbarService } from '../../../core/services/toolbar.service';

@Component({
standalone: false,
  selector: 'app-error-status',
  styleUrls: ['./error-status.component.scss'],
  templateUrl: './error-status.component.html',
})
export class ErrorStatusComponent {
  public status: string;

  constructor(private toolbar: ToolbarService, private route: ActivatedRoute) {
    this.toolbar.init(this.route);
    this.status = this.route.snapshot.paramMap.get('status');
  }

}
